import { render } from "./InputIndicators.vue?vue&type=template&id=265c70c5"
import script from "./InputIndicators.vue?vue&type=script&lang=js"
export * from "./InputIndicators.vue?vue&type=script&lang=js"
script.render = render

export default script